export default [{
  path: '/mit-apuracao',
  component: {
    name: 'mitApuracaoBase',
    template: '<router-view />',
    meta: {
      resource: 'mit_apuracao',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'mit-apuracao-view',
    component: () => import('@/app/mit-apuracao/MitApuracaoView.vue'),
    meta: {
      resource: 'mit_apuracao',
      action: 'read',
      navActiveLink: 'mit-apuracao-view',
      pageTitle: 'MIT',
      breadcrumb: [
        {
          text: 'MIT',
          to: { name: 'mit-apuracao-view' },
          active: true,
        },
      ],
    },
  }],
},
]
